"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartWallet = void 0;
const Error_1 = require("../../Error");
const Wallet_1 = require("../Wallet");
class SmartWallet extends Wallet_1.Wallet {
    /**
     * Sign transaction is not supported for smart wallets
     * @throws KriptonioError
     */
    signTransaction() {
        throw new Error_1.KriptonioError({
            message: 'smart accounts cannot sign transactions. send user operation instead',
        });
    }
}
exports.SmartWallet = SmartWallet;
